let constants = {
  setSocialIcons: "SET_SOCIAL_ICONS",
  setExperience: "SET_EXPERIENCE",
  setEducation: "SET_EDUCATION",
  setSkills: "SET_SKILLS",
  setProjects: "SET_PROJECTS",
};
export default constants;
